/**
 * Environment Configuration
 * Centralized environment variables and configuration
 */

import { resolveProductionApiBaseUrl } from '../helpers/productionApiUrl.helper';

// Simple environment detection - use EXPO_PUBLIC_ENV for consistency with api.ts
export const isProduction = process.env.EXPO_PUBLIC_ENV === 'production';
export const isDevelopment = !isProduction;

// API Configuration - using environment variables
export const API_CONFIG = {
  development: {
    baseUrl: process.env.EXPO_PUBLIC_API_URL_DEV ||process.env.REACT_APP_API_URL_DEV || 'http://localhost:3001/api/v1',
    timeout: 10000
  },
  production: {
    baseUrl: resolveProductionApiBaseUrl(
      process.env as Record<string, string | undefined>,
      typeof window !== 'undefined' && window.location != null ? window : undefined
    ),
    timeout: 15000
  }
};

// Current environment configuration
export const CURRENT_CONFIG = isDevelopment ? API_CONFIG.development : API_CONFIG.production;

// Production app origin (for auth redirects in emails so links never point to localhost)
export const PRODUCTION_APP_ORIGIN =
  process.env.EXPO_PUBLIC_APP_URL ?? 'https://zporti.com';

export const TURNSTILE_SITE_KEY = process.env.EXPO_PUBLIC_TURNSTILE_SITE_KEY ?? '';

// App Configuration
export const APP_CONFIG = {
  name: 'Zporti',
  version: '1.0.0',
  environment: process.env.REACT_APP_ENV || (isDevelopment ? 'development' : 'production'),
  debug: isDevelopment
};

// User Configuration - using environment variables
export const USER_CONFIG = {
  defaultUserId: process.env.REACT_APP_DEFAULT_USER_ID || 
    (isProduction ? '37c3dedb-1261-4991-8fa1-cb6c57ac93c0' : '550e8400-e29b-41d4-a716-446655440000'),
  maxRetries: 3,
  retryDelay: 1000
};
